

	import { Component, Watch } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { Artist, ArtistSearchRequest, PagedResult } from '@shared/models';
	import ArtistItem from '@client/views/industry/artists/ArtistItem.vue';

	@Component({
		components: {
			ArtistItem,
		},
	})
	export default class ProArtists extends BaseView {


		public modelId: string;
		public list: PagedResult<Artist> = new PagedResult<Artist>();
		public criteria: ArtistSearchRequest = new ArtistSearchRequest({ pageIndex: 0, pageSize: 32, sortBy: 'year', sortDirection: 'asc' });

		public async mounted() {
			await this.refresh();
		}

		@Watch('$route', { immediate: true, deep: true })
		public async refresh() {
			this.loading = true;
			try {
				this.criteria = new ArtistSearchRequest(this.$route.query);
				this.modelId = this.$route.params.id;
				this.criteria.proIds = [ this.modelId ];
				this.list = await this.$api.artistService.search(this.criteria);
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading this pros associated artists list');
			} finally {
				this.loading = false;
			}
		}

		/** Fires when the page is changed */
		public async pageChanged(page: number) {
			this.criteria.pageIndex = (page - 1);
			await this.filter(false);
		}

		/** Applies the specified filter and redirects to the new page with the correct query parameters */
		public async filter(resetPage: boolean) {
			this.scroll.scrollToTop();
			if (resetPage) { this.criteria.pageIndex = 0; }
			this.$router.push({ name: 'pro-artists', params: { id: this.modelId }, query: this.criteria.collapse() }).catch(() => { /* INTENTIONALLY EMPTY */ });
			await this.refresh();
		}



	}

